import {isNil} from 'ramda';

import {getAllDayHeaderElementId} from './getAllDayHeaderElementId';
import {getTimeSlotElementId} from './getTimeSlotElementId';

export const CALENDAR_START_HOUR = 8;

/**
 * Scrolls the calendar so the day opens at the given start hour
 * (defaults to CALENDAR_START_HOUR).
 *
 * The vertical scroll is owned by an ancestor (the app content area), not the
 * calendar's own grid, so we let `scrollIntoView` find and scroll that ancestor
 * for us. The start-hour slot carries a `scroll-margin-top` equal to the pinned
 * sticky chrome so the hour lands just below it instead of behind it.
 *
 * The all-day header is the lowest sticky element: its resolved sticky `top` is
 * the height of everything pinned above it (toolbar + day header) and its own
 * height completes the pinned stack. Measuring it — rather than the distance to
 * the top of the scroll container — keeps the offset correct regardless of any
 * non-sticky page content sitting above the calendar.
 *
 * Deferred one frame so the ancestor scroller and layout (all-day height,
 * fonts) have settled before measuring and scrolling.
 */
export function scrollToCalendarStart(testId: string, startHour: number = CALENDAR_START_HOUR) {
  const startSlot = document.getElementById(getTimeSlotElementId(testId, startHour));
  const stickyAnchor = document.getElementById(getAllDayHeaderElementId(testId));

  if (isNil(startSlot) || isNil(stickyAnchor)) {
    return;
  }

  requestAnimationFrame(() => {
    const stickyOffset =
      parseFloat(getComputedStyle(stickyAnchor).top) + stickyAnchor.getBoundingClientRect().height;

    startSlot.style.scrollMarginTop = `${stickyOffset}px`;
    startSlot.scrollIntoView({behavior: 'instant', block: 'start'});
  });
}
